import { render, staticRenderFns } from "./PropertyInvitationRoleItem.vue?vue&type=template&id=0d195d20&"
import script from "./PropertyInvitationRoleItem.vue?vue&type=script&lang=ts&"
export * from "./PropertyInvitationRoleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports